import { createAction, props } from '@ngrx/store';

export const setHttpError = createAction(
  '[General] Set http error',
  props<{ error: any }>()
);
